/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface GitHubUserSchema {
  login: string;
  html_url: string;
  name?: string | null;
  bio?: string | null;
  avatar_url?: string | null;
  public_repos?: number;
  followers?: number;
  following?: number;
  created_at: string;
}
